import React from 'react';
import { useSelector } from 'react-redux';
import classNames from 'clsx';

import { PageHeader } from 'app/components/PageHeader';
import { BrandAmbassadorSymbol } from 'app/components/BrandAmbassadorSymbol';
import { LabelEnum } from 'app/shared/enums';
import { CalculationViewPageHeaderProps } from './CalculationViewPageHeader.interface';
import { TestFormMicroCenterPageHeader } from 'app/components/TestFormMicroCenterPageHeader';
import { selectIsFormMicroCenterActive } from 'app/store/selectors/selectIsFormMicroCenterActive';
import { selectIsInFirstStepMode } from 'app/store/data/formsConfig';
import { ReactComponent as BackArrow } from 'app/assets/icons/back-arrow.svg';
import { FirstStepModePageHeader } from 'app/components/FirstStepModePageHeader';
import { selectIsFirstStepModeView } from 'app/store/selectors/selectIsFirstStepModeView';
import { useStyles } from './CalculationViewPageHeader.styles';
import { useCalculationViewPageHeader } from './useCalculationViewPageHeader';

export default function CalculationViewPageHeader(
  props: CalculationViewPageHeaderProps
) {
  const classes = useStyles();

  const isFormMicroCenterActive = useSelector(selectIsFormMicroCenterActive);
  const isInFirstStepMode = useSelector(selectIsInFirstStepMode);
  const isFirstStepModeView = useSelector(selectIsFirstStepModeView);
  const { onBackToStartClick } = useCalculationViewPageHeader();

  const getBackButton = () => (
    <div className={classes.topBackButtonContainer}>
      <span
        className={classNames(classes.topBackButton, 'focusVisibleOutline')}
        onClick={onBackToStartClick}
        tabIndex={0}
        onKeyDown={(e) => {
          if (
            e.target === e.currentTarget &&
            (e.key === 'Enter' || e.key === ' ')
          ) {
            e.preventDefault();
            onBackToStartClick();
          }
        }}
      >
        <BackArrow className={classes.backArrow} />
        {LabelEnum.GoBack}
      </span>
    </div>
  );

  if (isFormMicroCenterActive) {
    if (isFirstStepModeView) {
      return <FirstStepModePageHeader />;
    }

    if (isInFirstStepMode === undefined) {
      return null;
    }

    return (
      <>
        {getBackButton()}
        <TestFormMicroCenterPageHeader />
      </>
    );
  }

  return (
    <PageHeader
      newPageHeader
      title={
        <span>
          {LabelEnum.OcAndAcCalculator1} <em>{LabelEnum.OcAndAcCalculator2}</em>
        </span>
      }
      secondTitle={LabelEnum.CompareInsurances}
      renderAddon={BrandAmbassadorSymbol}
      dataCy={'calculation-view-header'}
      className={classes.pageHeader}
    />
  );
}
